module.exports = __webpack_public_path__ + "static/media/pga-logo-jobs-modal.15da2c63.png";